import dayjs from "dayjs"
import isBetween from "dayjs/plugin/isBetween"

dayjs.extend(isBetween)

const slotStatus = (startDate, endDate) => {
  const today = dayjs()

  if (today.isBetween(startDate, endDate, "[]")) return "live"

  if (today.isBefore(startDate)) return "upcoming"

  if (today.isAfter(endDate)) return "expired"
}

export default slotStatus
